<div layout="row" class="lock-size" layout-align="end right" ng-cloak="">
  <md-fab-speed-dial md-open="false" md-direction="up" class="md-fab-bottom-right md-fling md-scale"
                     ng-if="vm.buttons.dial">
    <md-fab-trigger>
      <md-button aria-label="menu" class="md-fab md-accent" ng-class="[vm.buttons.attrClass]">
        <md-icon ng-if="vm.buttons.icon">{{vm.buttons.icon}}</md-icon>
        <md-icon ng-if="vm.buttons.buttonImage" md-svg-src="{{vm.buttons.buttonImage}}" class="material-icons md-24" aria-label="more"></md-icon>
        <md-tooltip md-delay="50" md-direction="left">{{ vm.buttons.tooltip | translate }}</md-tooltip>
      </md-button>
    </md-fab-trigger>
    <md-fab-actions>
      <ng-repeat ng-repeat="action in vm.buttons.actions">
        <a ng-click="vm.goToNewState(action)" ng-if="action.changeState">
          <md-button aria-label="" class="md-fab md-raised md-mini" ng-class="[action.attrClass]">
            <md-icon ng-if="action.icon">{{action.icon}}</md-icon>
            <md-icon ng-if="action.buttonImage" md-svg-src="{{action.buttonImage}}" class="material-icons md-24" aria-label=""></md-icon>
            <md-tooltip md-delay="50" md-direction="left">{{ action.tooltip | translate }}</md-tooltip>
          </md-button>
        </a>
        <md-button aria-label="" class="md-fab md-raised md-mini" ng-class="[action.attrClass]"
                   ng-click="action.execute()" ng-if="!action.changeState">
          <md-icon ng-if="action.icon">{{action.icon}}</md-icon>
          <md-icon ng-if="action.buttonImage" md-svg-src="{{action.buttonImage}}" class="material-icons md-24" aria-label=""></md-icon>
          <md-tooltip md-delay="50" md-direction="left">{{ action.tooltip | translate }}</md-tooltip>
        </md-button>
      </ng-repeat>
    </md-fab-actions>
  </md-fab-speed-dial>
</div>
